import React from 'react'

import { Link } from 'react-router-dom'
import { LAYOUT_ADMIN_TEMPLATE_EDIT } from '../../navigation'
import { configureField } from '../../../../core/utils/list'

export const basicColumns = (props) => {
  const { loading, filters, resize, hidden } = props

  if (loading) return []

  return [
    {
      title: 'Name',
      dataIndex: 'name',
      ...configureField('t.name', filters, resize, hidden, true, false, false, 400),
      render: (name, record) => <Link to={LAYOUT_ADMIN_TEMPLATE_EDIT(record.id)}>{name}</Link>
    },
    {
      title: 'Type',
      dataIndex: 'type',
      ...configureField('t.type', filters, resize, hidden, true, true, true, 200)
    }
  ]
}
